import { render } from "./UsersIcon.vue?vue&type=template&id=9af0c84a"
const script = {}
script.render = render

export default script